import apiConfig from "../../config/api";
import trace from "../../helpers/trace";
import store from "../../config/store";
import { ErrorSnacktOpen } from "../ErrorSnack/actions";
import { cargarPrestaciones } from "../ActualizarArancel/FiltroBusqueda/actions";
const axios = require("axios");

export const cargarPaginacion = (paginacion) => ({
  type: "CARGAR_PAGINACION",
  paginacion,
});

export const cargarResultados = (prestacionesPP) => ({
  type: "CARGAR_PRESTACIONES_PP",
  prestacionesPP,
});

export const BuscarPrestacionesPP = (pagina, totalPagina) => (dispatch) => {
  const filtrosState = store.getState().filtroBusqueda;
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: globalState.filtros_CAT.centroAtencion,
    Arancel: globalState.filtros_CAT.tipoArancel,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    TipoAtencion: filtrosState.filtros.tipoAtencion === "0" ? null : filtrosState.filtros.tipoAtencion,
    Isapre: globalState.isapre,
    pageNumber: pagina,
    pageSize: totalPagina,
    token: globalState.token,
  };

  //console.log("PARAMETROS ANTES DE AXIOS");
  //console.log(params);

  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/prestaciones/prestador2/`,
    headers: {},
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    /*console.log("RESPONSE DESDE AXIOS API PRESTADOR2 PAGINACION V2");
    console.log(response.data);
    console.log(response.status);
    console.log(response.statusText);
    console.log(response.headers);
    console.log(response.config);*/

    if (response.status === 200) {
      /*console.log("RESPONSE OK");
      console.log(response.data);*/

      if (Array.isArray(response.data)) {
        //trace.information("BuscarPrestacionesPP", response.data);
        dispatch(cargarResultados(response.data));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarPrestaciones", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });

  // fetch(`${apiConfig.apiUri}/v1/prestaciones/prestador2/`, {
  //   method: "POST",
  //   headers: {
  //     // "Content-Type": "application/json",
  //     // Authorization: localStorage.getItem('id_token'),
  //   },
  //   credentials: "same-origin",
  //   body: JSON.stringify(params),
  // })
  //   .then((response) => {
  //     if (!response.ok) {
  //       throw response;
  //     }
  //     return response.json();
  //   })
  //   .then((json) => {
  //     if (Array.isArray(json)) {
  //       trace.information("BuscarPrestacionesPP", json);
  //       dispatch(cargarResultados(json));
  //     } else {
  //       throw json;
  //     }
  //   })
  //   .catch((error) => {
  //     trace.error("BuscarPrestacionesPP", error);
  //     dispatch(ErrorSnacktOpen(
  //       "Error al buscar las prestaciones:",
  //       error,
  //     ));
  //   });
};

export const CargarDatosPaginacion = (pagina) => (dispatch) => {
  const filtrosState = store.getState().filtroBusqueda;
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: globalState.filtros_CAT.centroAtencion,
    Arancel: globalState.filtros_CAT.tipoArancel,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    TipoAtencion: filtrosState.filtros.tipoAtencion === "0" ? null : filtrosState.filtros.tipoAtencion,
    Isapre: globalState.isapre,
    totalPagina: pagina,
    token: globalState.token,
  };

  //console.log("PAGINACION A MODIFICAR 2");

  axios({
    method: "POST",
    headers: {},
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
    url: `${apiConfig.apiUri}/v1/prestaciones/total-registros/`,
  }).then((response) => {
    if (response.status !== 200) {
      throw response.data;
    }

    if (Array.isArray(response.data)) {
      //trace.information("CargarDatosPaginacion", response.data);
      dispatch(cargarPaginacion(response.data));
    } else {
      throw response.data;
    }
  }).catch((error) => {
    trace.error("CargarDatosPaginacion", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });

  // fetch(`${apiConfig.apiUri}/v1/prestaciones/total-registros/`, {
  //   method: "POST",
  //   headers: {
  //     // "Content-Type": "application/json",
  //     // Authorization: localStorage.getItem('id_token'),
  //   },
  //   credentials: "same-origin",
  //   body: JSON.stringify(params),
  // })
  //   .then((response) => {
  //     if (!response.ok) {
  //       throw response;
  //     }
  //     return response.json();
  //   })
  //   .then((json) => {
  //     if (Array.isArray(json)) {
  //       trace.information("CargarDatosPaginacion", json);
  //       dispatch(cargarPaginacion(json));
  //     } else {
  //       throw json;
  //     }
  //   })
  //   .catch((error) => {
  //     trace.error("CargarDatosPaginacion", error);
  //     dispatch(ErrorSnacktOpen(
  //       "Error al buscar las prestaciones:",
  //       error,
  //     ));
  //   });
};



// WEBPACK FOOTER //
// ./src/components/PaginacionV2/action.js